import { DumbPastWinner } from 'components/landing/CommunityBlock/DumbPastWinner';
import { ACTUAL_ENV } from 'config';
import useQuery from 'hooks/graphql/useQuery';
import { NBA_PAST_WINNER_QUERY } from 'lib/usSportsGraphql/queries';

type Props = {
  leaderboardSlug: string;
};

export const NBAPastWinner = ({ leaderboardSlug }: Props) => {
  const { data } = useQuery(NBA_PAST_WINNER_QUERY, {
    skip: ACTUAL_ENV === 'mockprod',
  });

  const lastLeaderboard = data?.nbaPastFixtures.nodes[0]?.leaderboards?.find(
    leaderboard => leaderboard.slug.includes(leaderboardSlug)
  );

  if (!lastLeaderboard?.lineupsCount) return null;
  const winner = lastLeaderboard.lineups.nodes[0];

  return (
    <DumbPastWinner
      leaderboardIconUrl={lastLeaderboard.iconImageUrl}
      leaderboardName={lastLeaderboard.displayName}
      leaderboardRarity={lastLeaderboard.leaderboardRarity}
      lineupsCount={lastLeaderboard.lineupsCount}
      winner={{
        nickname: winner?.user?.nickname,
        avatarUrl: winner?.user?.avatarUrl,
      }}
      score={winner?.score}
      cards={winner?.cards.map(card => ({
        imageUrl: card.card.pictureUrl,
      }))}
    />
  );
};
